class GetMyZone extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.error = this.querySelector('[data-error]');
    this.success = this.querySelector('[data-success]');
    this.zipCode = this.querySelector('[data-zip-code]');
    this.zip = null;
    this.resultBox = this.querySelector('[data-result-box]');
    this.errorBox = this.querySelector('[data-error-box]');
    this.resultZip = this.querySelector('[data-result-zip]');
    this.resultZone = this.querySelector('[data-result-zone]');
    this.resultCity = this.querySelector('[data-result-city]');
    this.resultState = this.querySelector('[data-result-state]');
    this.zoneResultBox = this.querySelector('[data-zone-results]');
    this.zones = this.getAttribute('data-zones');
    this.zone = null;
    this.trimmedZone = null;
    this.zipCodes = [];
    if (
      !this.button ||
      !this.zipCode ||
      !this.zones ||
      !this.error ||
      !this.resultBox ||
      !this.resultZip ||
      !this.resultZone ||
      !this.resultCity ||
      !this.resultState ||
      !this.success
    ) {
      console.info('Required markup missing.');
      this.classList.add('hidden');
      return;
    }
    this.zones = this.zones.split(',');
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.zip = this.zipCode.value.trim();
      if (this.isValidUSZip(this.zip)) {
        this.findUSDA();
      } else {
        this.resultBox.classList.remove('success');
        this.error.classList.add('hidden');
        this.errorBox.classList.remove('hidden');
        this.resultBox.classList.add('hidden');
        this.success.classList.add('hidden');
      }
    });
  }

  isValidUSZip() {
    return /^\d{5}(-\d{4})?$/.test(this.zip);
  }

  findUSDA = () => {
    if (this.zipCodes.length) {
      this.searchData();
      return;
    }

    const response = fetch('//cdn.shopify.com/s/files/1/0061/1391/9089/files/usda_zone.csv')
      .then((response) => response.text())
      .then((data) => {
        const rows = data.split('\n');
        for (var i = 1, row; (row = rows[i]); i++) {
          const details = row.split(',');
          const detail = {
            zipCode: details[0],
            zone: details[1],
            city: details[2],
            state: details[3],
            trimmedZone: details[1].slice(0, -1)
          };
          this.zipCodes.push(detail);
        }
        this.searchData();
      })
      .catch((err) => console.log(err));
  };

  searchData = () => {
    if (!this.zipCodes.length) return;

    let matchingZone = -1,
      zone = null,
      city = null,
      state = null,
      isValidZip = true;

    const matchingZip = this.zipCodes.find((value, index) => {
      return value.zipCode === this.zip;
    });

    if (matchingZip) {
      matchingZone = this.zones.indexOf(matchingZip.trimmedZone);
      zone = matchingZip.trimmedZone;
      city = matchingZip.city + ',';
      state = matchingZip.state;
    } else {
      isValidZip = false;
    }

    this.resultZip.textContent = this.zip;
    this.resultZone.textContent = zone;
    this.resultCity.textContent = city;
    this.resultState.textContent = state;
    this.errorBox.classList.add('hidden');

    if (matchingZone >= 0) {
      this.error.classList.add('hidden');
      this.resultBox.classList.add('success');
      this.resultBox.classList.remove('hidden');
      this.success.classList.remove('hidden');
    } else {
      this.success.classList.add('hidden');
      this.error.textContent = `Not Compatible with Your Zone (${zone}).`;
      this.error.classList.remove('hidden');
      this.resultBox.classList.remove('hidden');
      this.resultBox.classList.remove('success');
    }
  };
}

customElements.define('get-my-zone', GetMyZone);
